import React, { FormEvent } from 'react'
import { useForm, Link } from '@inertiajs/react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { AuthLayout } from '@/components/layouts/AuthLayout'

interface ResetPasswordProps {
  reset_password_token: string
  minimum_password_length: number
}

export default function ResetPassword({ reset_password_token, minimum_password_length }: ResetPasswordProps) {
  const { data, setData, put, processing, errors } = useForm({
    agent: {
      reset_password_token,
      password: '',
      password_confirmation: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    put('/agents/password')
  }

  return (
    <AuthLayout title="Reset your password">
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <TextField
          label="New password"
          type="password"
          fullWidth
          autoFocus
          autoComplete="new-password"
          value={data.agent.password}
          onChange={e => setData('agent', { ...data.agent, password: e.target.value })}
          error={'agent.password' in errors}
          helperText={(errors as Record<string, string>)['agent.password'] || `${minimum_password_length} characters minimum`}
          sx={{ mb: 2.5 }}
        />
        <TextField
          label="Password confirmation"
          type="password"
          fullWidth
          autoComplete="new-password"
          value={data.agent.password_confirmation}
          onChange={e => setData('agent', { ...data.agent, password_confirmation: e.target.value })}
          error={'agent.password_confirmation' in errors}
          helperText={(errors as Record<string, string>)['agent.password_confirmation']}
          sx={{ mb: 3 }}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          disabled={processing}
          sx={{ mb: 2 }}
        >
          Reset password
        </Button>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            <Link href="/agents/sign_in" style={{ color: '#1a1a1a' }}>Back to sign in</Link>
          </Typography>
        </Box>
      </Box>
    </AuthLayout>
  )
}
